import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { bullseye1, kids, mission } from "../../assets/images";

const OurTarget = () => {
  return (
    <Box sx={{ width: "100vw", mb: { xs: "3rem" } }}>
      {/* Our story section */}
      <Container
        sx={{
          height: { md: "70vh" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          backgroundImage: `url(${mission})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: { md: "75vh" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            mb: { xs: 3 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            Our Mission
          </Typography>
          <Typography variant="h2" sx={{ width: "90%", mb: "1rem" }}>
            Empowering Lifelong {""}
            <span style={{ color: "#DB5430", textTransform: "uppercase" }}>
              Learners
            </span>
            {""} to {""}
            <span style={{ color: "#DB5430", textTransform: "uppercase" }}>
              Thrive and Lead
            </span>
            {""} in Every {""}
            <span style={{ color: "#DB5430", textTransform: "uppercase" }}>
              Season of Life
            </span>
          </Typography>
          <Typography>
            EAGLE creates opportunities for all children and youth across Africa
            to embark on{" "}
            <span style={{ color: "#DB5430" }}>holistic learning journeys</span>{" "}
            that are relevant and accessible, equipping learners to be
            productive professionals who are{" "}
            <span style={{ color: "#DB5430" }}>
              curious, courageous, and caring
            </span>{" "}
            contributors within their families and communities. The learning
            journeys are aligned with a skills-based framework for learning and
            growth, ensuring that all learners gain essential skills at every
            stage of life, challenging them in areas they love and supporting
            them in areas of weakness. As an EAGLE user advances along the
            journey, they grow in knowledge, skills and experiences that set
            them a part from other individuals and set them up to be
            productivity professionals.
          </Typography>
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            height: { xs: "50vh", md: "65%" },
            backgroundImage: `url(${kids})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 5,
          }}
        />
      </Container>
    </Box>
  );
};

export default OurTarget;
